import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import { EFQuestionMark1 } from '@/components/UI/svg/airConditioner';
import LinkIcon from '@/components/UI/svg/SaveElectric/Link';

export default function C() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('save_electric');
    const [showTips, setShowTips] = useState(false);

    return (
        <div className={`save-electric-c ${css.SaveElectricC}`}>
            <section className="section-a">
                <div className="text">{t('sec_3_text1')}</div>
                <Link
                    className="learn-more"
                    href="https://jp.ecoflow.com/pages/solar-panels"
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'store_activity',
                        page_name: '/jp/save-on-electric-bills',
                        list_name: 'Article',
                        button_name: t('sec_3_btn'),
                    }}
                >
                    {t('sec_3_btn')}
                </Link>
            </section>
            <section className="section-b section-text" onClick={() => setShowTips(false)}>
                <div className="text-wrapper">
                    <h3 className="sub-title">{t('sec_3_subtitle')}</h3>
                    <p className="title">{t('sec_3_title')}</p>
                    <div className="desc">
                        {t.rich('sec_3_desc', {
                            blue: (text: string) => (
                                <div className="blue">
                                    {text}
                                    <div
                                        className="icon"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowTips(true);
                                        }}
                                    >
                                        <EFQuestionMark1 width="15px" height="15px" fill={'#3F68E0'} />
                                    </div>
                                </div>
                            ),
                        })}
                    </div>
                    <Link
                        className="link_btn"
                        href="https://blog.ecoflow.com/jp/family-electric-bills/"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'select_news',
                            title_name: t('sec_3_title'),
                            button_name: t('sec_3_btn2'),
                        }}
                    >
                        {t('sec_3_btn2')}
                        <span className="icon icon-white">
                            <LinkIcon stroke="#000" width="0.14rem" height="0.14rem" />
                        </span>
                        <span className="icon icon-blue">
                            <LinkIcon stroke="#3f68e0" width="0.14rem" height="0.14rem" />
                        </span>
                    </Link>
                    <p className={`tips ${showTips ? 'show' : ''}`} onClick={(e) => e.stopPropagation()}>
                        {t('sec_3_tips')}
                    </p>
                </div>

                <NextImage
                    webpSrc={require('@publicLocal/save-electric/h5/4.webp')}
                    src={require('@publicLocal/save-electric/h5/4.jpg')}
                    alt={t('sec_3_title')}
                    aria-label={t('sec3_title')}
                />
            </section>
            <section className="section-c section-text">
                <div className="text-wrapper">
                    <h3 className="sub-title">{t('sec_4_subtitle')}</h3>
                    <p className="title">{t('sec_4_title')}</p>
                    <p className="desc">{t('sec_4_desc_h5')}</p>
                </div>
                <NextImage
                    webpSrc={require('@publicLocal/save-electric/h5/5.webp')}
                    src={require('@publicLocal/save-electric/h5/5.jpg')}
                    alt={t('sec_4_title')}
                    aria-label={t('sec_4_title')}
                />
            </section>
        </div>
    );
}
